import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {User, UserRecordFormProps} from '../types';

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: UserRecordFormProps) => {

    // Returned, not fired and forgotten: Formik keeps isSubmitting true until the
    // save settles, so the submit button stays disabled while it is in flight.
    const onSubmit = (values: User) => handleSubmit(values);

    let initialValues = {} as User;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
